var videoAutostart = 0;
var videoID = $('#home-video').attr('data-video-id');
var mobVideoId = $('#home-mobile-video').attr('data-video-id');
var deskplayer = $('#home-video').attr('id');
var mobplayer = $('#home-mobile-video').attr('id');
var player =$(".video__frame").attr('id');
var displayScreen = '';
var w1 = $(window).width();
var h1 = $(window).height();
if (w1 > 768) {
    player = deskplayer;
} else {
 player = mobplayer;
videoID = mobVideoId;
}
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;
var playing = false;
var currentTime = 0;
var expandPeriod = 100; // 100 miliseconds
var needToView = 3660; // seconds
function onYouTubeIframeAPIReady() {
    // Div player:
    player = new YT.Player(player, {
        height: '720',
        width: '1280',
        videoId: videoID,
        playerVars: {
            autoplay: 0,
            cc_load_policy: 0,
            controls: 1,
            disablekb: 1,
            fs: 1,
            playsinline: 1,
            modestbranding: 1,
            iv_load_policy: 3,
            rel: 0,
            showinfo: 0,
            host: 'https://www.youtube.com'
        },
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });
}
function onPlayerReady(event) {
    player.seekTo(currentTime);
    if (currentTime == 0) {
        if (videoAutostart) {
            player.mute();
          player.playVideo();      
        } else {
            player.unMute();
           player.pauseVideo();        
        }
    } else {
       
        player.pauseVideo();
    }

}


   function pausevideo(){
       if (player && typeof player.pauseVideo === 'function') {
    player.pauseVideo();
         $(".video__thumb").show();
         $(".video").removeClass('playing');
   }
}
   function playvideo(){
        if (player && typeof player.pauseVideo === 'function') {
       player.playVideo();
        $(".video__thumb").hide();
          document.querySelector('.video__thumb').style.display = 'none';

         $(".video").addClass('playing');  
               document.body.classList.add("body-overflow-visible");
          
   }
   }

$(".video__overlay").click(function() {
    console.log("click");
    if($('.video').hasClass('playing')) {
      console.log("if");
         player.pauseVideo();
        $(".video__thumb").show();
        $(".video").removeClass('playing');
    }else{
            console.log("else");
        player.playVideo();
        player.unMute();
      $(".video__thumb").hide();
        // $(".video__overlay").hide();
      $('.video .video__frame').css('pointer-events', 'all');
        $(".video").addClass('playing');  
    }
});


function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PAUSED) {
        playing = false;
    }
    if (event.data == YT.PlayerState.PLAYING) {
        playing = true;
    }
if (event.data === YT.PlayerState.ENDED) {
    console.log("END video...");
   $(".video.playing .video__overlay--thumb, .video__thumb").show();
  }
} 